/** Une clases condicionales sin dependencias externas (misma forma que Staff y Admin). */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
